import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import { Invoicing } from 'src/app/models/invoicing.interface';

@Injectable({
  providedIn: 'root'
})
export class InvoicingService {

  public invoicing: Invoicing = {
    businessName: '',
    hasLogoChanged: false,
    merchantLogo: '',
    merchantLogoUrl: '',
    merchantPhone: '',
    primaryBrandColor: '',
    secondaryBrandColor: ''
  };
  
  private invoicingSub$: BehaviorSubject<Invoicing> = new BehaviorSubject<Invoicing>(this.invoicing);
  invoicing$: Observable<Invoicing> = this.invoicingSub$.asObservable();

  constructor(
    private http: HttpClient,
  ) {}

  

  getInvoicing(): Observable<Invoicing> {
    return this.http.get<Invoicing>('api/invoicing');
  }

  setInvoicingData(invoicing: Invoicing): void {
    this.invoicing = invoicing;
    this.invoicingSub$.next(invoicing);
  }
}
